// Status badge (DESIGN.md 10.4): pill + icon + Chinese label. Never color-only.
// The pending-judgment pulse runs ONLY on under_review (the sole perpetual loop).

import type { FeedbackStatus } from '../lib/types';
import { STATUS_LABEL } from '../lib/types';
import type { Icon } from '../lib/icons';
import {
  PaperPlane,
  MagnifyingGlass,
  ChatCircleDots,
  SpinnerGap,
  CheckCircle,
  Check,
  ArrowCounterClockwise,
} from '../lib/icons';

const ICON: Record<FeedbackStatus, Icon> = {
  submitted: PaperPlane,
  under_review: MagnifyingGlass,
  awaiting_info: ChatCircleDots,
  in_progress: SpinnerGap,
  resolved: CheckCircle,
  confirmed: Check,
  reopened: ArrowCounterClockwise,
};

export function StatusBadge({ status, withPulse = false }: { status: FeedbackStatus; withPulse?: boolean }) {
  const Icon = ICON[status];
  const pulse = withPulse && status === 'under_review';
  return (
    <span className={`badge badge-${status}`}>
      <Icon weight="regular" />
      <span>{STATUS_LABEL[status]}</span>
      {pulse && <span className="badge-pulse" aria-hidden="true" />}
    </span>
  );
}
